import React, { useEffect, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Подключение стилей

const TextEditor = ({ value, setValue }) => {
  // const [value, setValue] = useState('');
  const ref = useRef(null);
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }], // Заголовки
      ['bold', 'italic', 'underline', 'strike'], // Форматирование текста
      [{ list: 'ordered' }, { list: 'bullet' }], // Списки
      [{ script: 'sub' }, { script: 'super' }], // Нижний и верхний индекс
      [{ align: [] }], // Выравнивание текста
      ['link', 'image'], // Ссылки и изображения
      [{ color: [] }, { background: [] }], // Цвет текста и фона
      ['clean'], // Удаление форматирования
    ],
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'list',
    'bullet',
    'script',
    'align',
    'link',
    'image',
    'color',
    'background',
  ];

  return (
    <div>
      <ReactQuill
        value={value}
        onChange={(e) => setValue(e)}
        modules={modules}
        on
        formats={formats}
        style={{
          resize: 'vertical',
          overflowY: 'auto',
          transition: 'none',
        }}
        theme="snow"
      />
    </div>
  );
};

export default TextEditor;
